'use strict';

exports.__esModule = true;
exports.default = checkIsMobile;
var MOBILE_OS = ['android', 'webos', 'iphone', 'ipad', 'ipod', 'blackberry', 'iemobile', 'opera mini'];

/**
 * Mobile device detection
 *
 * @param  {String} userAgent - user agent string
 * @return {Boolean} device is mobile
 */
function checkIsMobile(userAgent) {
  return new RegExp('' + MOBILE_OS.join('|'), 'i').test(userAgent);
}
module.exports = exports['default'];